// @flow

//
// React
//
import React from 'react';

//
// Material UI
//
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

//
// Formatter
//
import {
    fmtDate,
    fmtTime,
    fmtMoney,
} from '../../../../../lib/trix-web-data-commons';

//
// Component
//
const createPaymentTransactionTableCellRenderer = (cfg: any): any => (props: any): any => {
    const row = (props.row) ? props.row : {};

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'stretch',
                    paddingTop: 1,
                    paddingBottom: 1,
                    gap: 2,
                    justifyContent: 'space-between',
                    width: '100%',
                }}
            >
                <Stack>
                    <Typography variant='subtitle2' display='block'>
                        {fmtDate(row.documentDate)}
                    </Typography>
                    <Typography variant='subtitle2' display='block'>
                        {fmtTime(row.documentDate)}
                    </Typography>
                </Stack>

                <Box 
                    sx={{
                        flexGrow: 1,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-end',
                    }}
                >
                    <Stack>
                        <Typography 
                            variant='subtitle1' 
                            color='text.secondary' 
                            sx={{ textAlign: 'right', width: '100%' }}
                        >
                            {fmtMoney(row.amount)}
                        </Typography>

                        <Typography 
                            variant='subtitle2' 
                            display='block' 
                            sx={{ 
                                fontWeight: 600,
                                paddingTop: 1,
                                textAlign: 'right', 
                                width: '100%'
                            }}
                        >
                            {(row && row.paymentAccount) ? row.paymentAccount.name : ''}
                        </Typography>
                    </Stack>
                </Box>
            </Box> 
        </>
    );
}

const createPaymentTransactionTableColumn = (cfg: any): any => { 
    return {
        flex: true,
        width: 100,

        renderCell: createPaymentTransactionTableCellRenderer({
            ...cfg.cellRendererFactoryProps,
        })
    }
};
export default createPaymentTransactionTableColumn;
